import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Image } from 'react-bootstrap';
//import logoYec from '../../assets/yec.svg';
import logoCSP from '../../assets/logo_csp.svg'



export default function FooterHook() {

    useEffect(() => {
        
    }, []);



    return (
        <>
            <Container id="footer" fluid className='bg-light p-3'>
                <Container fluid className='text-end'>
                    <Image src={logoCSP} width='160' />
                    <p className='text-secondary small'>
                        <span className='small'>© Powered by <Link to='/license'>GRUPPO YEC Srl</Link></span><br/>
                    </p>
                </Container>
            </Container>
        </>
    )
};